import React from 'react';
import Checkmark from '../../assets/images/icons/checkmark.svg';
import Minus from '../../assets/images/icons/minus.svg';
import Styles from './Checkbox.module.scss';

const Checkbox = (props) => {
  const {
    defaultChecked,
    disabled,
    onclick,
    isChecked,
    selectedAll,
    selectAllCheckbox,
  } = props;

  const getCheckboxIcon = () => {
    if (selectAllCheckbox && selectedAll === 'INDETERMINATE') {
      return <img src={Minus} alt="minus" />;
    }

    if (isChecked) {
      return <img src={Checkmark} alt="checkmark" />;
    }

    return '';
  };

  return (
    <button
      className={`${Styles.checkbox} 
      ${isChecked || selectedAll === 'INDETERMINATE' ? Styles.checked : ''} ${
      disabled ? Styles.disabled : ''
    }
      ${selectAllCheckbox ? Styles.selectAll : ''}`}
      type="button"
      defaultChecked={defaultChecked}
      disabled={disabled}
      onClick={() => onclick && onclick()}
    >
      {getCheckboxIcon()}
    </button>
  );
};

export default Checkbox;
